import React, { useState, useEffect } from "react";

import './DownloadFile.css';

import { SetModalState, RegisterModalData, RegisterModalObserver, SetModalData } from "interface/PopUp";

import { Reg_CopyBudget, Reg_CopyService, Reg_Delete, Reg_OpenBudget, Reg_Reactivate } from "services/RegisterData";

import { GetUserData, RegisterUserData } from "interface/Users";
import { SvgClose } from "components/SvgFile";
import { GetDataPage } from "interface/Data";

import * as XLSX from 'xlsx';

export default function PopUP_DownloadFile(){

    const [ loading, setLoading ]     = useState(false);
    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    useEffect(()=>{
        RegisterModalData('DownloadFile', setModaldata);
        RegisterModalObserver('DownloadFile', setShowPopUp);
    }, []);

    function TypeDownload(type){
        if(type === 'txt'){
            let conteudo = '';

            GetDataPage('client').forEach(empresa => {
                conteudo += `Empresa = ${empresa.name}\n`;
                empresa.contact.forEach(contato => {
                    conteudo += `   - Nome: ${contato.name}\n`;
                    conteudo += `   - Email: ${contato.email}\n`;
                    conteudo += `   - Contato: ${contato.phone}\n\n`;
                });
            });

            // Cria o blob e link para download
            const blob = new Blob([conteudo], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'lista dos clientes.txt';
            link.click();
            URL.revokeObjectURL(url);

        }else if(type === 'excel'){
            // Constrói as linhas para a planilha
            const linhas = [];

            GetDataPage('client').forEach(empresa => {
                empresa.contact.forEach(contato => {
                    linhas.push({
                    Empresa: empresa.name,
                    Nome: contato.name,
                    Email: contato.email,
                    Contato: contato.phone
                    });
                });
            });

            // Converte em planilha
            const worksheet = XLSX.utils.json_to_sheet(linhas);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Contatos");

            // Salva como arquivo
            XLSX.writeFile(workbook, "lista dos clientes.xlsx");            
        }
        ClosePopUp();
    }

    function ClosePopUp(){
        SetModalState('DownloadFile', false);
    }

    return (
        (showPopUp ?
            <>
                <div className={ loading == true ? "return_data_save div_loading" : "return_data_save" }>
                    <img alt="loading" src="./assets/loading.gif" className="loading" />
                </div>
                <div className="PopUp">
                    <div className="all DownloadFile">
                        <div className="div_data type_div">
                            <div className="title">
                                Download dos e-mails
                            </div>
                            <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                                <SvgClose color="#F00000" className="icons" />
                            </div>
                        </div>
                        <div className="div_data list_inf_content" style={ { paddingTop: 0 } }>
                            <div className="">
                                Escolha uma formato a baixo
                            </div>
                            <div className="content div_confirmation">
                                <div onClick={ ()=>{ TypeDownload('excel'); } }>
                                    <div className="opt_select yes_update">Excel</div>
                                </div>
                                <div onClick={ ()=>{ TypeDownload('txt'); } }>
                                    <div className="opt_select yes_update">Txt</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        : <React.Fragment></React.Fragment>)
    );
}
